import { CardText as _CardText, CardTextProps as _CardTextProps } from "reactstrap";

    export const CardText = _CardText;
    export type CardTextProps = _CardTextProps;
    